import { FlexRow } from '@/components/common/Flex';
import FinancialEntityRelinkButton from '@/components/financialEntities/FinancialEntityRelinkButton';
import FinancialEntityWithMask from '@/components/financialEntities/FinancialEntityWithMask';
import { FlexProps } from '@chakra-ui/react';
import { ExternalFinancialEntity } from '@common/financialEntities';
import Banner from '../common/Banner';
import { Link03, LinkBroken01 } from '../common/icons';
import { FinancialEntityIcon } from '../financialEntities/FinancialEntityIcon';

export interface FinancialEntityRelinkWarningProps extends FlexProps {
    account: ExternalFinancialEntity;
    includeFinancialEntityWithMask: boolean;
}

export default function FinancialEntityRelinkWarning({
    account,
    includeFinancialEntityWithMask,
    ...props
}: FinancialEntityRelinkWarningProps) {
    return (
        <Banner
            icon={
                includeFinancialEntityWithMask ? (
                    <FlexRow alignItems="center" gap={2}>
                        <FinancialEntityIcon fe={account} w={6} h={6} />
                        <LinkBroken01 color="black" />
                    </FlexRow>
                ) : (
                    <Link03 />
                )
            }
            button={
                <FinancialEntityRelinkButton
                    account={account}
                    title="Reconnect"
                />
            }
            {...props}
        >
            {includeFinancialEntityWithMask ? (
                <>
                    <FinancialEntityWithMask fe={account} mr={1} />
                    needs to be reconnected
                </>
            ) : (
                'Reconnect your account to get up-to-date balances.'
            )}
        </Banner>
    );
}
